import React, { createContext, useState, useEffect, useContext } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {
    Typography, Box, IconButton, Button,
    Card, CardHeader, CardContent, List, ListItem
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useNavigate } from "react-router-dom";
import { useTournamentContext } from './context';
import axios from './utils/axios';

export default function MainMenu() {
    const navigate = useNavigate()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const { apiURL } = useTournamentContext();

    const [ tournaments, setTournaments ] = useState([])

    const path = window.location.pathname;
    const id_tournament = path.split('/')[2];

    useEffect(() => {
        axios.get(apiURL('tournaments')).then(payload => {
            setTournaments(payload?.data)

            if(!id_tournament){
                window.location.href = `/tournament/${payload.data[0]?.id}`
            }
        })
    }, [])

    return (
      <div>
        <IconButton
            size="large"
            edge="start"
            color="inherit"
            sx={{ mr: 2 }}
            onClick={handleClick}
        >
            <MenuIcon />
        </IconButton>

        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
        >
            {tournaments.sort((a, b) => new Date(a.date_from) - new Date(b.date_from)).map(t => (
                <MenuItem onClick={() => window.location.href = `/tournament/${t.id}`}>
                    {t.name} {t.date_formatted}
                </MenuItem>
            ))}
        </Menu>
      </div>
    );
}
